import styled from 'styled-components'

import { ButtonIcon } from '@/components/business/visitor-parking/button-icon'

export const Footer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  width: '100%',
}))

export const PrivacyPolicyText = styled.p(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.2rem',
  fontWeight: 500,
}))

export const PrivacyPolicyLink = styled.a(({ theme }) => ({
  color: theme.colors.black500,
  fontWeight: 700,
  textDecoration: 'underline',
}))

export const ButtonsContainer = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'space-between',
  width: '100%',
}))

export const BackButton = styled(ButtonIcon)({
  height: '5.6rem',
  width: '5.6rem',
})
